module.exports = __webpack_public_path__ + "static/media/21460016-b2S0wSgs.f95d30e2.JPG";